import { HttpResponse } from '@angular/common/http';
import { InjectableApi } from '@shared/decorators';
import { ApiService } from '@shared/services';
import { ForceAny } from '@shared/typescript';
import { Observable } from 'rxjs';

@InjectableApi({
  providedIn: 'root',
  baseSegment: '/auth',
})
export class AuthService extends ApiService {
  /**
   * @function refreshToken To refresh expired access token.
   * @returns An Observable with new set of tokens.
   */
  refreshToken(query: string): Observable<HttpResponse<ForceAny>> {
    return this.headersGetRequest(`/refresh-token${query}`, 'v1');
  }

  refreshTokenCookie(): Observable<HttpResponse<ForceAny>> {
    return this.headersGetRequest(`/refresh-token`, 'v1');
  }
}
